import { GenericField } from "./GenericFields";
import { Element } from "./Element";
import { Column } from "./Column";


export class Entity {
    id: number;
    entityName: string;
    type: string;
    icon:string;
    objectcategory:string;
    fieldMap:Map<number,GenericField>;
    //fields:GenericField[];
    elements:Element[];
    columns:Column[];

    constructor()
    {
      
       this.elements=new Array();
       //this.fields = new Array();
       this.fieldMap = new Map;
    }

  }